import React from 'react'

function Bitcoinlogo() {
  return (
    <>
    <svg className='justify-center mx-auto text-center items-center w-12 md:w-16' version="1.0" xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 571.000000 627.000000"
                preserveAspectRatio="xMidYMid meet">
                <g transform="translate(0.000000,627.000000) scale(0.100000,-0.100000)"
                  fill="#dfc660" stroke="none">
                  <path d="M2097 5863 c-4 -3 -7 -179 -7 -390 l0 -383 -475 0 -475 0 0 -249 0
                  -248 193 -6 c277 -7 331 -24 392 -121 l30 -49 3 -1066 c2 -750 0 -1081 -8
                  -1117 -11 -52 -39 -88 -90 -115 -18 -10 -82 -15 -222 -17 l-197 -4 -5 -27 c-3
                  -14 -24 -134 -46 -266 -22 -132 -43 -250 -45 -262 l-5 -23 475 0 475 0 0 -385
                  0 -385 245 0 245 0 0 385 0 385 180 0 180 0 0 -385 0 -385 245 0 245 0 0 389
                  0 389 68 7 c231 21 288 28 390 45 207 37 397 110 558 215 229 149 347 357 385
                  679 15 129 7 371 -16 456 -37 139 -119 278 -212 360 -89 78 -249 159 -382 193
                  l-51 13 69 47 c132 90 197 160 246 261 62 128 85 231 85 386 -1 342 -128 556
                  -430 723 -140 77 -398 145 -622 163 l-88 7 0 394 0 393 -242 -2 -243 -3 -3
                  -387 -2 -388 -180 0 -180 0 0 390 0 390 -238 0 c-131 0 -242 -3 -245 -7z
                  m1013 -1323 c279 -35 458 -128 532 -277 27 -55 33 -80 36 -153 11 -224 -96
                  -355 -358 -439 -127 -41 -226 -53 -487 -58 l-253 -6 0 466 0 466 28 4 c59 9
                  422 6 502 -3z m139 -1425 c410 -62 597 -180 641 -403 47 -237 -73 -424 -332
                  -517 -211 -76 -452 -102 -895 -96 l-83 1 0 515 0 514 78 4 c159 8 489 -2 591
                  -18z"/>
                </g>
              </svg>
    </>
  )
}

export default Bitcoinlogo